export default {
  meta: {
    title: '踩点分析结果',
    url: '/footprinting/report', // 埋点用，记录所属模块
    // eventId: '0578f821-39a5-4f8f-8192-f6259afdaa32'
  },
};
